import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(Router);

// For each route, you assign a component that gets rendered inside <router-view></router-view> in App.vue, just below the navbar (see App.vue).
// I'm not sure why the Vue CLI created two different directories, views and components, but I think they meant for components that are full views
// to be put in views, and just modular components to be put in components. Here, we can use either components in the views dir (like Callback and About),
// or in the components dir. Doesn't really seem to matter, as components can always house other components.
// Yes, seems like it's really just convention - https://stackoverflow.com/questions/50865828/what-is-the-difference-between-the-views-and-components-folders-in-a-vue-project
// And, according to this, views directory didn't use to exist - https://blog.pusher.com/new-vue-cli-simplifies-development/
// BTW, you can also have named router views - https://router.vuejs.org/guide/essentials/named-views.html#nested-named-views
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    // https://router.vuejs.org/guide/essentials/dynamic-matching.html
    {
      path: '/story/:id',
      name: 'story',
      component: () => import(/* webpackChunkName: "test" */ '../views/Story.vue'),
    },
    {
      path: '/user/:id',
      name: 'user',
      // route level code-splitting: generates a separate chunk (test.[hash].js) for this route which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "test" */ '../views/User.vue'),
    },
    {
      path: '/confirm/:code',
      name: 'confirm',
      component: () => import(/* webpackChunkName: "test" */ '../views/Confirm.vue'),
    },
    {
      path: '/m/:code',
      name: 'm',
      component: () => import(/* webpackChunkName: "test" */ '../views/MagicURL.vue'),
    },
    {
      path: '/unsubscribe/:code',
      name: 'unsubscribe',
      component: () => import(/* webpackChunkName: "test" */ '../views/Unsubscribe.vue'),
    },
    {
      path: '/forgotpassword/:code',
      name: 'forgotpassword',
      component: () => import(/* webpackChunkName: "test" */ '../views/ForgotPassword.vue'),
    },
    {
      path: '/circleRequests',
      name: 'circleRequests',
      component: () => import(/* webpackChunkName: "test" */ '../views/CircleRequests.vue'),
    },
    {
      path: '/adminSendSupportText',
      name: 'adminSendSupportText',
      component: () => import(/* webpackChunkName: "test" */ '../views/AdminSendSupportText.vue'),
    },
    {
      path: '/blog/:id',
      name: 'blog',
      component: () => import(/* webpackChunkName: "test" */ '../views/Blog.vue'),
    },
    {
      path: '/lander/:id',
      name: 'lander',
      component: () => import(/* webpackChunkName: "test" */ '../views/Lander.vue'),
    },
    {
      // we maintain this even though we have the modal, because FB and other third parties might need a direct link
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: () => import(/* webpackChunkName: "test" */ '../views/PrivacyPolicy.vue'),
    },
    {
      path: '/pose/:storyTellerId',
      name: 'pose',
      component: () => import(/* webpackChunkName: "test" */ '../views/Pose.vue'),
    },


  ],
});

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {
  // if the to route doesn't match any defined routes, redirect to /
  if (to.matched.length === 0) {
    console.log(`router.beforeEach() found no matches for ${JSON.stringify(to)}`)
    next('/')
  }

  if (to.name && to.name.includes('callback')) { // check if "to"-route is "callback" and allow access
    next();
  } else {
    next();
  }
});

export default router;

